import React from "react";
import PropTypes from "prop-types";

const HiddenFormFields = ({ authenticityToken }) => (
  <React.Fragment>
    <input name="utf8" type="hidden" value="✓" />
    <input type="hidden" name="authenticity_token" value={authenticityToken} />
  </React.Fragment>
);

HiddenFormFields.propTypes = {
  authenticityToken: PropTypes.string.isRequired,
};

export default HiddenFormFields;
